import React, { useState, useEffect } from "react";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import MetaTags from "react-meta-tags";
import CircularProgress from "@material-ui/core/CircularProgress";
import Pagination from "@material-ui/lab/Pagination";
import { getCareerCategory, getCareerPagination } from "../../action/career";
import GetCareer from "../../components/card/GetCareer";

export default function Career() {
  const [career, setCareer] = useState({});
  const [buttonCategory, setButtonCategory] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [idCategory, setIdCategory] = useState("0");
  const [isLoading, setIsLoading] = useState(true);

  const perks = [
    {
      title: "Pertumbuhan Karir",
      desc: "Kembangkan potensi terbaik Anda di industri FinTech & SaaS kuliner yang berkembang pesat.",
    },
    {
      title: "Budaya Kolaboratif",
      desc: "Bekerja bersama tim yang suportif, adaptif, dan selalu terbuka untuk ide-ide baru.",
    },
    {
      title: "Keseimbangan & Tunjangan",
      desc: "Lingkungan kerja fleksibel, asuransi kesehatan, dan fasilitas kerja yang mendukung.",
    },
  ];

  useEffect(() => {
    getCareerCategory().then((result) => {
      if (result && result.success === 1 && result.categories) {
        let listCategory = [{ value: "0", label: "Semua Posisi" }];
        result.categories.forEach((cat) => {
          listCategory.push({ value: cat.id, label: cat.name });
        });
        setButtonCategory(listCategory);
      }
    });

    getCareerPagination(page, idCategory).then((result) => {
      if (result && result.careers) {
        setCareer(result.careers);
        const count = result.count || 1;
        setTotalPage(Math.ceil(count / 10));
      }
      setIsLoading(false);
    });
  }, [page, idCategory]);

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  return (
    <div style={{ maxWidth: "100%", overflowX: "hidden", backgroundColor: "#ffffff" }}>
      <MetaTags>
        <title>Karir di UR | Bergabung Bersama Kami</title>
        <meta name="title" content="Karir di UR" />
        <meta
          name="description"
          content="Bergabunglah dengan tim inovatif UR. Temukan berbagai peluang karir menarik di bidang teknologi dan bisnis."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ur-hub.com/karir" />
      </MetaTags>

      {/* Hero Section */}
      <section
        style={{
          paddingTop: "130px",
          paddingBottom: "64px",
          backgroundColor: "#0f172a",
          color: "#ffffff",
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={4} alignItems="center" justify="space-between">
            <Grid item xs={12} md={7}>
              <div
                style={{
                  color: "#DE148C",
                  fontSize: "13px",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                  marginBottom: "12px",
                }}
              >
                Peluang Karir
              </div>

              <Typography
                variant="h1"
                style={{
                  fontWeight: 800,
                  fontSize: "clamp(2rem, 4vw, 3.2rem)",
                  lineHeight: 1.2,
                  letterSpacing: "-0.02em",
                  marginBottom: "14px",
                }}
              >
                Karir di UR
              </Typography>

              <Typography
                variant="subtitle1"
                style={{
                  color: "#94a3b8",
                  fontSize: "15px",
                  lineHeight: 1.6,
                  maxWidth: "520px",
                }}
              >
                Kami mencari talenta kreatif dan bersemangat tinggi untuk bersama-sama menciptakan solusi digital terbaik bagi ekosistem kuliner Indonesia.
              </Typography>
            </Grid>

            {/* Illustration */}
            <Grid item xs={12} md={5} style={{ textAlign: "center" }}>
              <img
                src="https://ik.imagekit.io/urhub/assets/misc/join-us.png"
                alt="Join Us"
                style={{
                  maxHeight: "220px",
                  width: "auto",
                }}
              />
            </Grid>
          </Grid>
        </Container>
      </section>

      {/* Perks Section */}
      <section style={{ padding: "48px 0", backgroundColor: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
        <Container maxWidth="lg">
          <Grid container spacing={3}>
            {perks.map((perk, idx) => (
              <Grid item xs={12} md={4} key={idx}>
                <div
                  style={{
                    backgroundColor: "#ffffff",
                    borderRadius: "14px",
                    padding: "24px",
                    height: "100%",
                    border: "1px solid #e2e8f0",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ fontWeight: 700, fontSize: "16px", color: "#0f172a", marginBottom: "6px" }}
                  >
                    {perk.title}
                  </Typography>
                  <p style={{ color: "#64748b", fontSize: "14px", lineHeight: 1.6, margin: 0 }}>
                    {perk.desc}
                  </p>
                </div>
              </Grid>
            ))}
          </Grid>
        </Container>
      </section>

      {/* Job Openings Section */}
      <section style={{ padding: "64px 0 80px 0" }}>
        <Container maxWidth="lg">
          <div style={{ textAlign: "center", marginBottom: "36px" }}>
            <Typography
              variant="h2"
              style={{
                fontWeight: 800,
                color: "#0f172a",
                fontSize: "24px",
                marginBottom: "6px",
              }}
            >
              Posisi yang Tersedia
            </Typography>
            <p style={{ color: "#64748b", fontSize: "14px", margin: 0 }}>
              Pilih departemen untuk menyaring posisi yang cocok dengan keahlian Anda.
            </p>

            {/* Department Filter Pills */}
            <div
              style={{
                display: "flex",
                gap: "6px",
                flexWrap: "wrap",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              {buttonCategory.map((cat) => (
                <button
                  key={cat.label}
                  onClick={() => setIdCategory(cat.value)}
                  style={{
                    padding: "6px 16px",
                    borderRadius: "6px",
                    border: idCategory === cat.value ? "1px solid #DE148C" : "1px solid #e2e8f0",
                    backgroundColor: idCategory === cat.value ? "#DE148C" : "#ffffff",
                    color: idCategory === cat.value ? "#ffffff" : "#64748b",
                    fontWeight: 500,
                    fontSize: "13px",
                    cursor: "pointer",
                    transition: "all 0.15s ease",
                  }}
                >
                  {cat.label}
                </button>
              ))}
            </div>
          </div>

          {/* Listings */}
          <div style={{ maxWidth: "800px", margin: "0 auto" }}>
            {isLoading ? (
              <div style={{ textAlign: "center", padding: "60px 0" }}>
                <CircularProgress style={{ color: "#DE148C" }} />
              </div>
            ) : career && Object.keys(career).length > 0 ? (
              Object.entries(career).map((data, idx) => (
                <GetCareer key={idx} data={data} />
              ))
            ) : (
              <div style={{ textAlign: "center", padding: "60px 0", color: "#64748b" }}>
                <p>Saat ini belum ada posisi baru yang dibuka untuk kategori ini.</p>
              </div>
            )}

            {/* Pagination */}
            <div style={{ display: "flex", justifyContent: "center", marginTop: "36px" }}>
              <Pagination
                count={totalPage}
                page={page}
                onChange={handleChangePage}
                color="primary"
              />
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
}
